import React from 'react';
import styles from './index.module.scss';
import { useEffect, useState } from 'react';

const DeliveryMethods = (props) => {
  const { selectedCard, onSelect, nextRoutedDeliveryAvailableDays, isOnDemandDeliveryPossible } = props;
  
  const [deliveryMethods, setDeliveryMethods] = useState<any[]>([]);
  const getDeliveryMethods = () => {
    const immediateMethods = isOnDemandDeliveryPossible ? [{ name: 'On Demand (Immediately)', type: 'IMMEDIATE' }] : [];
    const routableMethods = nextRoutedDeliveryAvailableDays ? nextRoutedDeliveryAvailableDays.map(
      item => {
        return {
          name: `Routed (${item})`,
          type: 'ROUTABLE',
          preferredDeliveryDay: item,
        };
      },
    ) : [];

    return [
      ...immediateMethods,
      ...routableMethods,
    ];
  };
  
  useEffect(()=>{
    const deliveryMethodsTemp = getDeliveryMethods();
    setDeliveryMethods(deliveryMethodsTemp);
    if(deliveryMethodsTemp.length > 0){
      onSelect(deliveryMethodsTemp[0]);
    }
  }, []);

  const renderMethod = (item) => {
    const { name, type, preferredDeliveryDay } = item;
    return(
      <div className={styles[`delivery-method-view-tile`]}>
        <div className={`${styles['delivery-method-selector-container']}`}>
          <input
            type="radio"
            className={styles['delivery-method-selector-radio']}
            id={`${type}_${preferredDeliveryDay}`}
            checked={type === selectedCard?.deliveryMethod && preferredDeliveryDay === selectedCard?.preferredDeliveryDay}
            onChange={() => {onSelect(item)}}
          />
          <label htmlFor={`${type}_${preferredDeliveryDay}`}></label>
        </div>
        <div className={styles['name']}>{name}</div>
      </div>
    );
  };

  return(
    <div className={styles['delivery-method-container']}>
      <div className={styles['heading']}>Choose delivery Method</div>
      {deliveryMethods.map((item)=>{
        return renderMethod(item);
      })}
    </div>
  );
};

export default DeliveryMethods;